import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectUser } from '../selectors/auth'

interface NoPracticeGuardProps {
	children?: React.ReactNode
}

const NoPracticeGuard = ({ children }: NoPracticeGuardProps) => {
	const user = useSelector(selectUser)

	if (user && user.primaryClinic === 'confused') {
		return <Navigate to="/dashboard" />
	}

	return <>{children}</>
}

export default NoPracticeGuard
